<template>
    <div id="index">
        <!-- banner -->
        <div class="banner-wrap">
            <!-- //设置轮播图外层基本样式：大小，背景颜色等 -->
            <div class="swiper-page">
                <!-- //设置相对定位，用于定位左右箭头 -->
                <div class="container-list">
                    <swiper :options="swiperOptions">
                        <swiper-slide v-for="(item, index) in slideList" :key="index">
                            <div class="container">
                                <img :src="item.detail" width="100%" height="100%" alt="">
                            </div>
                        </swiper-slide>
                    </swiper>
                    <!-- //分页、左右箭头，样式名字需与配置项、css中类名相同 -->
                    <div class="swiper-pagination1" slot="pagination"></div>
                    <div class="swiper-button-next1" slot="button-next"></div>
                    <div class="swiper-button-prev1" slot="button-prev"></div>
                </div>
            </div>
            <div class="search">
                <form action="" class="search-form">
                    <input type="text" v-model="indexSearch" placeholder="搜索职位名称" />
                </form>
                <img src="@/assets/img/search.png" class="search-icon" @click="goSearch" alt="" />
            </div>
        </div>
        <!-- search -->
        <!-- 名企招聘 -->
        <div class="well-campany">
            <div class="wrap">
                <div class="index-tit-wrap">
                    <h2 class="index-tit">名企招聘</h2>
                    <div class="update-date" @click="updateDate">
                        <img src="@/assets/img/update.png" class="update-icon" :class="{ 'update-icon-on': isUpdate }"
                            alt="" />
                        换一批
                    </div>
                </div>
                <WellCompany :wellCompanyData="wellCompanyData"></WellCompany>
            </div>
        </div>
        <!-- 最新职位 -->
        <div class="newest-job">
            <div class="wrap">
                <div class="index-tit-wrap">
                    <h2 class="index-tit">最新职位</h2>
                    <div class="update-date" @click="updateDateJob">
                        <img src="@/assets/img/update.png" class="update-icon" :class="{ 'update-icon-on': isUpdateJob }"
                            alt="" />
                        换一批
                    </div>
                </div>
                <NewJob :newJobData="newJobData"></NewJob>
            </div>
        </div>
        <main class="index-main">
            <div class="wrap">
                <!-- 应届 -->
                <h2 class="index-tit">应届</h2>
                <ul class="internship">
                    <li class="internship-item" v-for="(item, index) in reigningData"
                        @click="goJob(item.jobId, item.clientId)" :key="index">
                        <span class="internship-loc internship-loc-f">[{{ item.areaCodeStr }}]</span>
                        <p class="internship-info">{{ item.jobName }}</p>
                        <span class="internship-loc">立即申请</span>
                    </li>
                </ul>
                <!-- 实习 -->
                <h2 class="index-tit">实习</h2>
                <ul class="internship">
                    <li class="internship-item" v-for="(item, index) in internshipData"
                        @click="goJob(item.jobId, item.clientId)" :key="index">
                        <span class="internship-loc internship-loc-f">[{{ item.areaCodeStr }}]</span>
                        <p class="internship-info">{{ item.jobName }}</p>
                        <span class="internship-loc">立即申请</span>
                    </li>
                </ul>
            </div>
        </main>
    </div>
</template>
<script>
import NewJob from "@/components/NewJob.vue";
import WellCompany from "@/components/WellCompany.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {
    getClientList,
    getNewJobList,
    getReigningList,
    getInternshipList,
} from "@/api/home.js";

export default {
    components: {
        WellCompany,
        NewJob,
        swiper,
        swiperSlide
    },
    data() {
        return {
            wellCompanyData: [],
            wellCompanyTotalPage: 22,
            wellCompanyEnd: 3,
            wellCompanyNow: 1,
            newJobData: [],
            newJobTotalPage: 22,
            newJobEnd: 3,
            newJobNow: 1,
            reigningData: [
                {
                    jobId: 1,
                    jobName: "人力资源实习生-流程管理部",
                    areaCodeStr: "北京",
                },
            ],
            internshipData: [
                {
                    jobId: 1,
                    jobName: "人力资源实习生-流程管理部",
                    areaCodeStr: "北京",
                },
            ],
            isUpdate: false,
            isUpdateJob: false,
            indexSearch: "",
            swiperOptions: {
                loop: true,//无限循环
                autoplay: {
                    //自动切换
                    delay: 2500,
                    stopOnLastSlide: false, //切换到最后一个slide时停止自动切换
                    disableOnInteraction: false, //用户操作swiper之后，是否禁止自动切换。默认为true
                },
                // 显示分页
                pagination: {
                    el: ".swiper-pagination1",//若改变分页样式，需改变样式名字，默认为.swiper-pagination
                    type: "bullets",
                    clickable: true, //允许分页点击跳转
                },
                // 设置点击箭头
                navigation: {
                    nextEl: ".swiper-button-next1",//若改变右箭头样式，需改变名字，默认为.swiper-button-next
                    prevEl: ".swiper-button-prev1",//若改变左箭头样式，需改变名字，默认为.swiper-button-prev
                },
            },
            //数据列表
            slideList: [
                {
                    detail: require('../../assets/img/banner-1.jpg'),
                },
                {
                    detail: require('../../assets/img/banner-2.jpg'),
                },
                {
                    detail: require('../../assets/img/banner-3.jpg'),
                },
                {
                    detail: require('../../assets/img/banner-4.png'),
                },
                {
                    detail: require('../../assets/img/banner-5.png'),
                },
            ],
        };
    },
    created() {
        // 首页名企招聘
        this.getClient(1, 8);
        // 首页最新职位
        this.getNewJob(1, 6);
        this.getReigning(10);
        this.getInternship(10);
    },
    methods: {
        onSlideChange() {
            console.log('slide change');
        },
        onSwiper(swiper) {
            console.log(swiper);
        },

        // 换一批
        updateDate() {
            if (this.wellCompanyTotalPage != 1) {
                this.isUpdate = !this.isUpdate;
                // 换一批页码数加一
                this.wellCompanyNow = this.wellCompanyNow + 1;
                // 向下取整
                if (this.wellCompanyNow == this.wellCompanyTotalPage) {
                    this.getClient(this.wellCompanyNow, this.wellCompanyEnd);
                    this.wellCompanyNow = 0;
                } else {
                    this.getClient(this.wellCompanyNow, 8);
                }
            } else {
                this.$message.warning("只有这么多数据了！");
            }
        },
        updateDateJob() {
            if (this.newJobTotalPage != 1) {
                this.isUpdateJob = !this.isUpdateJob;
                this.newJobNow = this.newJobNow + 1;
                if (this.newJobNow == this.newJobTotalPage) {
                    this.getNewJob(this.newJobNow, this.newJobEnd);
                    this.newJobNow = 0;
                } else {
                    this.getNewJob(this.newJobNow, 6);
                }
            } else {
                this.$message.warning("只有这么多数据了！");
            }
        },
        // 首页名企招聘
        getClient(pageIndex, pageSize) {
            let data = {
                pageIndex: pageIndex,
                pageSize: pageSize,
            };
            getClientList(data)
                .then((res) => {
                    if (res.success) {
                        this.wellCompanyData = res.data;
                        this.wellCompanyTotalPage = Math.ceil(res.totalCount / 8);
                        this.wellCompanyEnd = res.totalCount % 8;
                        if (this.wellCompanyEnd == 0) {
                            this.wellCompanyEnd = 8;
                        }
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });
        },
        // 首页最新职位
        getNewJob(pageIndex, pageSize) {
            let data = {
                pageIndex: pageIndex,
                pageSize: pageSize,
            };
            getNewJobList(data)
                .then((res) => {
                    if (res.success) {
                        this.newJobData = res.data;
                        this.newJobTotalPage = Math.ceil(res.totalCount / 6);
                        this.newJobEnd = res.totalCount % 6;
                        if (this.newJobEnd == 0) {
                            this.newJobEnd = 6;
                        }
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });
        },
        // 首页应届
        getReigning(pageSize) {
            let data = {
                pageSize: pageSize,
            };
            getReigningList(data)
                .then((res) => {
                    if (res.success) {
                        this.reigningData = res.data;
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });
        },
        // 首页实习
        getInternship(pageSize) {
            let data = {
                pageSize: pageSize,
            };
            getInternshipList(data)
                .then((res) => {
                    if (res.success) {
                        this.internshipData = res.data;
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });
        },
        goSearch() {
            this.$router.push({
                path: "/search",
                query: { name: this.indexSearch },
            });
        },
        goJob(id, clientId) {
            this.$router.push({
                path: "/job",
                query: { id: id, clientId: clientId },
            });
        },
    },
};
</script>
<style scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}

.banner-wrap {
    position: relative;
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.banner {
    position: absolute;
    width: 100%;
    height: 500px;
    object-fit: cover;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
}

.banner-tit {
    position: relative;
    z-index: 2;
    text-align: center;
}

.banner-title {
    color: #fff;
    font-size: 52px;
    margin-bottom: 14px;
    line-height: 55px;
    letter-spacing: 3px;
}

.banner-desc {
    color: #fff;
    font-size: 18px;
    letter-spacing: 2px;
}

.index-tit-wrap {
    display: flex;
    justify-content: space-between;
}

.index-tit {
    font-size: 30px;
    color: #333;
    font-weight: 500;
    margin-bottom: 38px;
}

.search {
    position: absolute;
    bottom: -26px;
    width: 700px;
    height: 54px;
    display: flex;
    align-items: center;
    padding: 6px 18px;
    border: 1px solid #3b87ff;
    border-radius: 27px;
    background: #fff;
    box-shadow: 0px 6px 15px 0px #e5e5e5;
    z-index: 2;
}

.search-form {
    flex: 1;
}

.search-icon {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.well-campany {
    padding: 40px 0;
    background: url("./../../assets/img/index_bg1.png") 100% no-repeat;
}

.newest-job {
    background: #fff;
    padding: 40px 0;
}

.update-date {
    height: 30px;
    display: flex;
    align-items: center;
    padding: 5px 15px;
    border-radius: 15px;
    font-size: 14px;
    border: 1px solid #3b87ff;
    color: #3b87ff;
    cursor: pointer;
}

.update-icon {
    width: 12px;
    height: 12px;
    margin-right: 10px;
    transition: all 0.3s ease-in;
}

.update-icon-on {
    transform: rotate(360deg);
    transition: all 0.3s ease-in;
}

.index-main {
    padding: 0 0 40px;
    background: url("./../../assets/img/index_bg2.png") 100% no-repeat;
}

.index-main .index-tit {
    padding-top: 40px;
}

.internship {
    background: #fff;
    padding: 25px 30px;
    display: flex;
    flex-wrap: wrap;
}

.internship-item {
    width: 50%;
    display: flex;
    align-items: center;
    line-height: 24px;
    cursor: pointer;
    padding-right: 130px;
}

.internship-item:hover .internship-loc,
.internship-item:hover .internship-info {
    text-decoration: underline;
}

.internship-loc {
    color: #3b87ff;
}

.internship-loc-f {
    max-width: 120px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}

.internship-info {
    padding: 0 8px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    flex: 1;
}







.swiper-page {
    /* //设置轮播图外层基本样式：大小，背景颜色等 */
    width: 100%;
    box-sizing: border-box;
}

.container-list {
    /* //设置相对定位，用于定位左右箭头 */
    position: relative;
}

/* //设置轮播图整体样式 */
.swiper-container {
    width: 100%;
    height: 500px;
    background: rgba(21, 102, 131, 0.5);
    border-radius: 5px;
}

/* //设置右箭头样式 */
.swiper-button-next1 {
    width: 30px;
    height: 30px;
    background: url('./../../assets/img/banner-right.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: calc(50% - 25px);
    right: 0;
    z-index: 3;
    cursor: pointer;
}

/* //设置左箭头样式 */
.swiper-button-prev1 {
    width: 30px;
    height: 30px;
    background: url('./../../assets/img/banner-left.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: calc(50% - 25px);
    left: 0;
    z-index: 3;
    cursor: pointer;
}

/* //设置分页样式 */
.swiper-pagination1 {
    /* //居中显示 */
    text-align: center;
    margin: 0;
}

::v-deep .swiper-pagination-bullet {
    /* //深度修改swiper分页按钮样式 */
    width: 24px;
    height: 4px;
    /* background: url('../assets/images/active.png') no-repeat; */
    background-size: 100% 100%;
    border-radius: 0;
    margin: 0 1px;
}

.container {
    height: 100%;
}

.detail {
    color: #FFF;
}</style>
